// extracted by mini-css-extract-plugin
module.exports = {"Outros":"Outros_Outros__cfzFk","Selected":"Outros_Selected__35zXN"};